<template>
  <div class="homePage-page">
    <div class="today-details-container">
      <!-- <div class="addCrops-container" style="width: 10%" @click="handleToCrop">
        <span> <i class="el-icon-plus"></i>添加 </span>
      </div> -->
      <div class="grow-select-container" style="width: 20%">
        <div class="select-container select-container-mid">
          <select name="szjd" v-model="selectid" @change="groupChange()">
            <option v-for="(itema, index1) in grouponelist" :key="index1" :value="itema.id">
              {{ itema.name }}
            </option>
          </select>
        </div>
        <span v-if="selectid == 0" style="color: #236cff; cursor: pointer; margin-right: 10px; font-size: 12px" @click="hanldeHomeGroup()">配置</span>
      </div>
      <div class="early-warning-container" @click="handleToAlarm">
        <span class="waring_lable">预警：</span>
        <marqueeLeft v-if="alermlist.length > 0" :sendVal="alermlist"></marqueeLeft>
      </div>

      <div class="today-weather-container" style="width: 22%">
        <div class="container_1" v-if="weatherList.length > 0">
          <div class="todayW content_1">今天：天气{{ weatherList[0].textDay }} {{ weatherList[0].tempMin }}℃~{{ weatherList[0].tempMax }}℃</div>
          <div class="todayW content_1">明天：天气{{ weatherList[1].textDay }} {{ weatherList[1].tempMin }}℃~{{ weatherList[1].tempMax }}℃</div>
          <div class="todayW content_1">后天：天气{{ weatherList[2].textDay }} {{ weatherList[2].tempMin }}℃~{{ weatherList[2].tempMax }}℃</div>
        </div>

        <span class="todayB">
          <el-link type="primary" :underline="false" @click="handleOpenWeather">
            <span style="font-size: 14px"> 一周天气 </span>
            <i class="el-icon-arrow-right"></i>
          </el-link>
        </span>
      </div>
      <!-- <div class="today-weather-container" style="width: 12%">
        <span class="todayB" style="width: 100%">
          <el-link type="primary" :underline="false" @click="handleScreen">
            可视化大屏
            <i class="el-icon-arrow-right"></i>
          </el-link>
        </span>
      </div> -->
    </div>
    <div v-if="chong_show != -1" class="chong_box">
      <div style="margin-top: 40px">
        <!-- <el-tabs v-model="activeName">
          <el-tab-pane :lazy="true" label="虫情仪" name="first"> </el-tab-pane>
          <el-tab-pane :lazy="true" label="气象站" name="second"></el-tab-pane>
          <el-tab-pane :lazy="true" label="水质检测" name="third"></el-tab-pane>
          <el-tab-pane :lazy="true" label="孢子设备" name="fourth"></el-tab-pane>
        </el-tabs> -->
      </div>
      <div @click="scrollToSection" class="bottom">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <div @click="scrollToSection(4)" class="chong_box_show">
      <div class="cirle"></div>
      <div class="device_name_title">虫情仪 {{ deviceCountList.length > 0 ? deviceCountList[5].deviceNum : '' }}</div>

      <img src="../../assets/img/cqy.png" alt="" />
    </div>
    <div @click="scrollToSection(3)" class="chong_box_show qxz">
      <div class="cirle"></div>
      <div class="device_name_title">气象站{{ deviceCountList.length > 0 ? deviceCountList[6].deviceNum : '' }}</div>
      <img src="../../assets/img/qxz.png" alt="" />
    </div>

    <div @click="scrollToSection(2)" class="chong_box_show sz">
      <div class="cirle"></div>
      <div class="device_name_title">孢子{{ deviceCountList.length > 0 ? deviceCountList[7].deviceNum : '' }}</div>
      <img src="../../assets/img/bz.png" alt="" />
    </div>
    <div @click="scrollToSection(1)" class="chong_box_show bz">
      <div class="cirle"></div>
      <div class="device_name_title">水质检测{{ deviceCountList.length > 0 ? deviceCountList[8].deviceNum : '' }}</div>
      <img src="../../assets/img/szjc.png" alt="" />
    </div>
    <div class="device" v-if="device_show">
      <div class="device_title">
        <div class="cirle"></div>
        设备数量统计
      </div>
      <div v-for="item in deviceCountList.slice(0, 5)" class="deviceList" :key="item.id">
        <div>
          <img :src="item.img" alt="" />
        </div>
        <div style="margin-left: 10px">
          <div class="device_name" v-if="item.type == 0">数值</div>
          <div class="device_name" v-if="item.type == 1">开关</div>
          <div class="device_name" v-if="item.type == 2">网关</div>
          <div class="device_name" v-if="item.type == 3">图片</div>
          <div class="device_name" v-if="item.type == 4">视频</div>
          <div class="device_name" v-if="item.type == 5">虫情</div>
          <div class="device_name" v-if="item.type == 6">气象</div>
          <div class="device_name" v-if="item.type == 7">孢子</div>
          <div class="device_name" v-if="item.type == 8">水质</div>
          <div class="device_num">
            <div>
              总数: <span style="color: black">{{ item.type == 0 || item.type == 1 ? item.attributeNum : item.deviceNum }}</span>
              <span v-if="item.attributeOfflineNum !== null">
                离线:<span style="color: red">{{ item.attributeOfflineNum }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div @click="device_show = !device_show" class="bottom">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <div v-if="!device_show" @click="device_show = !device_show" class="device_box_show">
      <img style="margin-right: 8px" src="../../assets/img/device.png" alt="" />
      <div class="cirle"></div>
      设备数量统计
    </div>

    <div v-loading="isLoading" class="all-content-container_" style="background: #fff; padding: 20px 0; /* min-height: 300px; */">
      <div class="empty-box" v-if="greenHouseRealData.length == 0 && deviceCountList.length > 0 ? deviceCountList[5].deviceNum > 0 && deviceCountList[6].deviceNum > 0 && deviceCountList[7].deviceNum > 0 && deviceCountList[8].deviceNum > 0 : false">
        <img :src="empty_img" />
      </div>
      <div>
        <div class="dapeng-box" v-for="(item, index) in greenHouseRealData" :key="index" @click="handleToGroupDetail(item.groupId)">
          <h2 class="dapeng-title">
            {{ item.groupName }}
            <!-- <span class="dapeng-child-title" v-if="item.growthName">（）</span>
          <font class="dapeng-child-time">{{ item.updateTime }}</font> -->
          </h2>
          <!-- <img class="dapeng-img" v-if="index % 2 == 1" src="~@/static/img/homeGreenhouse1.png" /> -->
          <img class="dapeng-img" :src="require(`../../assets/images/bg${item.homeGroupType}.png`)" />
          <div class="dapeng-row">
            <div :class="`dapeng-span${index2}`" v-for="(item2, index2) in item.realDataOneList" :key="index2 + '1'">
              <img class="dapeng-list-img" :src="item2.image" />
              <div>
                <span class="hiden_span" :style="'color:' + item2.colorType">{{ item2.cname }}</span>
                <span class="hiden_span2" :style="'color:' + item2.colorType">{{ item2.realDataConvert + (item2.symbol ? item2.symbol : '') }}</span>
                <!-- <span class="hiden_span a666" :style="'color:' + item2.colorType">{{
                item2.updateTime
              }}</span> -->
              </div>
            </div>

            <!-- <div class="dapeng-span" v-for="(item2, index2) in item.realDataTwoList" :key="index2 + '2'">
              <img class="dapeng-list-img" :src="item2.image" />
              <div>
                <span class="hiden_span" :style="'color:' + item2.colorType">{{ item2.cname }}</span>
                <span class="hiden_span2" :style="'color:' + item2.colorType">{{ item2.realDataConvert + (item2.symbol ? item2.symbol : '') }}</span>
              </div>
            </div> -->
          </div>
          <!-- <img class="dapeng-video" title="查看视频" src="~@/static/img/video.png" /> -->
        </div>
        <div class="dapeng-box" v-for="item in devicewaterQualityMonitoringList" :key="item.id" v-if="devicewaterQualityMonitoringList.length > 0">
          <WaterQualityMonitoring :numericalDevices="item" class="listshow1" ref="water"></WaterQualityMonitoring>
        </div>
        <div class="dapeng-box" v-for="item in deviceSporeList" :key="item.id" v-if="deviceSporeList.length > 0">
          <sporeDevice :numericalDevices="item" class="listshow2" ref="water" />
        </div>
        <div class="dapeng-box" v-for="item in deviceMeteoroList" :key="item.id" v-if="deviceMeteoroList.length > 0">
          <MeteorologicalStation :numericalDevices="item" class="listshow3"></MeteorologicalStation>
        </div>
        <div class="dapeng-box" v-for="(item, index) in deviceInsectDetectorList" :key="item.id" v-if="deviceInsectDetectorList.length > 0">
          <div class="center_text">{{ item.deviceName }}</div>
          <InsectDetector :numericalDevices="item" :index="index" class="listshow4"></InsectDetector>
        </div>
      </div>
    </div>
    <el-dialog style="zoom: 0.8" :title="addressDivide + '未来一周天气概况'" :visible.sync="weatherDialogVisible" width="850px;">
      <div class="today-weather">
        <div class="today-weather-title">
          <!-- <img v-if="weatherList_.wType == 0" src="../../static/img/weather-ty.png" />
          <img v-else-if="weatherList_.wType == 3" src="../../static/img/weather-xy.png" />
          <img v-else-if="weatherList_.wType == 2" src="../../static/img/weather-dy.png" />
          <img v-else src="../../static/img/weather-day.png" /> -->
          <i v-if="weatherList_.length > 0" style="font-size: 110px" :class="`qi-${weatherList_[0].iconDay}`"></i>
          <span v-if="weatherList_.length > 0">{{ weatherList_[0].tempMin }}~{{ weatherList_[0].tempMax }}℃</span>
        </div>
        <p v-if="weatherList_.length > 0">今天：{{ weatherList_[0].fxDate }}&nbsp;</p>
        <p v-if="weatherList_.length > 0" class="imgP">
          <!-- <i>
            <img src="../../static/img/feng.png" alt class="imgPp" />
          </i> -->
          {{ weatherList_[0].textDay }}
        </p>
      </div>
      <div class="week-wather">
        <el-row :gutter="20">
          <el-col v-if="index != 0" :span="4" v-for="(item, index) in weatherList_" :key="index">
            <div class="grid-content bg-purple">
              <p style="font-size: 20px">{{ item.fxDate }}</p>
              <div class="imgDiv">
                <!-- <img v-if="item.Wtype == 0" src="../../static/img/week-ty.png" alt />
                <img v-else-if="item.Wtype == 1" src="../../static/img/week-day.png" alt />
                <img v-else-if="item.Wtype == 2" src="../../static/img/week-dy.png" alt />
                <img v-else src="../../static/img/week-xy.png" alt /> -->
                <i style="font-size: 40px" :class="`qi-${item.iconDay}`"></i>
              </div>
              <p style="font-size: 18px">{{ item.tempMin }}~{{ item.tempMax }}℃</p>
              <p style="font-size: 16px">{{ item.textDay }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import InsectDetector from './InsectDetector.vue'
import MeteorologicalStation from './meteorologicalStation.vue'
import WaterQualityMonitoring from './waterQualityMonitoring.vue'
import sporeDevice from './sporeDevice.vue'
import 'animate.css'
import marqueeLeft from '@/components/marqaee.vue'
export default {
  components: {
    marqueeLeft,
    InsectDetector,
    MeteorologicalStation,
    WaterQualityMonitoring,
    sporeDevice
  },
  data() {
    return {
      device_show: true,
      activeName: 'first',
      isLoading: false,
      disabled: false,
      chong_show: -1,
      citys: this.$utils.getCityList(),
      province: [],
      provinceid: 30,
      city: [],
      cityid: '',
      alermlist: [],
      empty_img: require('../../assets/img/timg.jpg'),
      selectid: '',
      grouponelist: [],
      msg: 'gaojin',
      weatherList: [],
      weatherDialogVisible: false,
      name: '',
      id: '',
      date: '', // 时间
      greenHouseRealData: [], // 分组实时数据
      isFirstDefault: true, // 是否首次默认，如果首次默认查询数据为空，那么自动跳第二个分组查询数据
      cityCode: '',
      weatherList_: [],
      addressDivide: '',
      deviceCountList: [],
      deviceSporeList: [],
      deviceMeteoroList: [],
      deviceInsectDetectorList: [],
      devicewaterQualityMonitoringList: []
    }
  },
  watch: {
    provinceid(val) {
      if (val) {
        let c = this.citys
        let city = []
        for (let i of c) {
          if (i.pid == val) {
            city = [...city, i]
          }
        }
        this.city = city
        // this.cityid = '101210106'
      }
    }
    // cityid(val) {
    //   if (val) {
    //     this.getWeather(val)
    //   }
    // }
  },
  beforeCreate() {
    this.$forceUpdate()
  },
  created() {
    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致

    this.getConfigGroupOne()
    this.getCity()
    // this.getWeather()
    // this.getHomeMonitorList()
    this.timer = setInterval(() => {
      _this.getNewGreenHouseRealData() // 分组实时数据
    }, 30000)
    this.timer1 = setInterval(() => {
      _this.date = new Date() // 时间
    }, 30000)

    setTimeout(() => {
      this.isLoading = false
    }, 10000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.timer1) {
      clearInterval(this.timer1)
    }
  },
  methods: {
    getHMS(timestamp) {
      var date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '/'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    getHomeMonitorList() {
      //获取分组列表
      this.$api.device.getHomeMonitorList({ type: 3, groupId: this.selectid }).then(res => {
        if (res.code == 200) {
          this.deviceSporeList = res.data
          this.deviceSporeList.map(item => {
            item.numericalDevices.map(c => {
              c.updateTime = this.getHMS(c.updateTime)
            })
          })
        }
      })
      this.$api.device.getHomeMonitorList({ type: 2, groupId: this.selectid }).then(res => {
        if (res.code == 200) {
          this.devicewaterQualityMonitoringList = res.data
          this.devicewaterQualityMonitoringList.map(item => {
            item.numericalDevices.map(c => {
              c.updateTime = this.getHMS(c.updateTime)
            })
          })
        }
      })
      this.$api.device.getHomeMonitorList({ type: 1, groupId: this.selectid }).then(res => {
        if (res.code == 200) {
          this.deviceMeteoroList = res.data
          this.deviceMeteoroList.map(item => {
            item.numericalDevices.map(c => {
              c.updateTime = this.getHMS(c.updateTime)
            })
          })
        }
      })
      // 虫情仪
      this.$api.device.getHomeMonitorList({ type: 0, groupId: this.selectid }).then(res => {
        if (res.code == 200) {
          this.deviceInsectDetectorList = res.data
          this.deviceInsectDetectorList.map(item => {
            item.numericalDevices.map(c => {
              c.updateTime = this.getHMS(c.updateTime)
            })
          })
        }
      })
      this.$forceUpdate()
    },
    scrollToSection(num) {
      var el = document.getElementsByClassName(`listshow${num}`)[0]
      el.scrollIntoView({
        behavior: 'smooth'
      })
    },
    getHomeDeviceCount() {
      this.$api.device.getHomeDeviceCount({ userId: sessionStorage.getItem('USER_ID'), groupId: this.selectid }).then(res => {
        if (res.code == 200) {
          res.data.map(item => {
            item.img = require(`../../assets/img/device${item.type}.png`)
          })
          this.deviceCountList = res.data
        }
      })
    },
    // 一级分组下拉切换
    groupChange(val) {
      this.grouponelist.map(item => {
        if (item.id == this.selectid) {
          this.cityCode = item.addressCode
        }
      })
      this.getAlarmList()
      this.getNewGreenHouseRealData()
      this.getHomeMonitorList()
      this.getHomeDeviceCount()
    },
    // 查询告警滚动列表
    async getAlarmList() {
      await this.$api.system.getAlarmList().then(res => {
        if (res.code == 200) {
          this.alermlist = res.data
        }
      })
    },
    // 二级
    changeTreeItem(val) {
      this.dialogformInline.parentId = val[val.length - 1]
      this.formInline.organization = val[val.length - 1]
    },
    // 获取分组实时数据
    getNewGreenHouseRealData() {
      this.isLoading = true
      this.$api.homeParam.getNewGreenHouseRealData({ id: this.selectid }).then(res => {
        this.isLoading = false
        if (res.code == 200) {
          this.greenHouseRealData = res.data
          console.log(res.data, 666)
          console.log(this.grouponelist[1], 969)
          // 如果首次默认查询数据为空，那么自动跳第二个分组查询数据
          if (this.isFirstDefault && this.selectid == 0 && this.greenHouseRealData.length == 0 && this.grouponelist.length > 1) {
            this.selectid = this.grouponelist[1].id
            this.getNewGreenHouseRealData()
          }
          this.getConfigGroup()
          this.isFirstDefault = false
          this.getAlarmList()
          this.getHomeDeviceCount()
          this.getHomeMonitorList()
        }
      })
    },
    getConfigGroup() {
      this.$api.system.getConfigGroup({ id: this.selectid }).then(res => {
        this.cityCode = res.data.addressCode
        this.addressDivide = res.data.addressDivide
        this.getWeather()
      })
    },
    // 跳转分组详情
    handleToGroupDetail(greenHouseId) {
      this.$router.push({
        name: 'index2',
        query: {
          greenHouseId: greenHouseId,
          oneGroupId: this.selectid,
          cityCode: this.cityCode,
          addressDivide: this.addressDivide
        }
      })
    },
    // 获取城市列表
    getCity() {
      let citys = this.citys
      let pro = []
      for (let i of citys) {
        if (i.pid == 0) {
          pro = [...pro, i]
        }
      }
      this.province = pro
    },
    // 获取天气数据
    getWeather(id) {
      this.$api.system
        .getHfPreWeather({ str: this.cityCode })
        .then(res => {
          if (res.code == 200) {
            // if (res.data.type == '小到中雨') {
            //   res.data.wType = 1
            // } else if (res.data.type == '阴' || res.data.type == '多云') {
            //   res.data.wType = 2
            // } else if (res.data.type == '小雨') {
            //   res.data.wType = 3
            // } else if (res.data.type == '晴') {
            //   res.data.wType = 0
            // }
            // for (var i = 0; i < res.data.forecast.length; i++) {
            //   if (res.data.forecast[i].type == '小到中雨') {
            //     res.data.forecast[i].Wtype = 1
            //   } else if (res.data.forecast[i].type == '阴' || res.data.forecast[i].type == '多云') {
            //     res.data.forecast[i].Wtype = 2
            //   } else if (res.data.forecast[i].type == '小雨') {
            //     res.data.forecast[i].Wtype = 3
            //   } else if (res.data.forecast[i].type == '晴') {
            //     res.data.forecast[i].Wtype = 0
            //   }
            // }
            this.weatherList = res.data
            console.log(this.weatherList)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    get7Weather() {
      this.$api.system
        .getHfPreWeather({ str: this.cityCode })
        .then(res => {
          if (res.code == 200) {
            // if (res.data.type == '小到中雨') {
            //   res.data.wType = 1
            // } else if (res.data.type == '阴' || res.data.type == '多云') {
            //   res.data.wType = 2
            // } else if (res.data.type == '小雨') {
            //   res.data.wType = 3
            // } else if (res.data.type == '晴') {
            //   res.data.wType = 0
            // }
            // for (var i = 0; i < res.data.forecast.length; i++) {
            //   if (res.data.forecast[i].type == '小到中雨') {
            //     res.data.forecast[i].Wtype = 1
            //   } else if (res.data.forecast[i].type == '阴' || res.data.forecast[i].type == '多云') {
            //     res.data.forecast[i].Wtype = 2
            //   } else if (res.data.forecast[i].type == '小雨') {
            //     res.data.forecast[i].Wtype = 3
            //   } else if (res.data.forecast[i].type == '晴') {
            //     res.data.forecast[i].Wtype = 0
            //   }
            // }
            this.weatherList_ = res.data
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    // 打开天气弹窗
    handleOpenWeather() {
      this.provinceid = 30
      // this.cityid = '101210106'
      let c = this.citys
      let city = []
      for (let i of c) {
        if (i.pid == 30) {
          city = [...city, i]
        }
      }
      this.city = city
      this.weatherDialogVisible = true
      this.get7Weather()
    },
    // 跳转农作物界面
    handleToCrop() {
      this.$router.push({
        name: 'cropsManagement'
      })
    },
    // 跳转告警界面
    handleToAlarm() {
      this.$router.push({
        name: 'alarmPredictions',
        query: { currentShow: 'pane1', currentShow2: 'pane3' }
      })
      this.$refs.pass.moreBth()
    },
    // 获取一级分组
    async getConfigGroupOne() {
      await this.$api.system.getConfigGroupOne().then(res => {
        if (res.code == 200) {
          this.grouponelist = res.data
          // 第一位加个默认
          this.selectid = res.data[0].id
          this.cityCode = res.data[0].addressCode
          this.getWeather()

          this.getNewGreenHouseRealData()
        }
      })
    },
    // 跳转首页分组配置界面
    hanldeHomeGroup() {
      this.$router.push({
        name: `homeGroup`,
        query: {}
      })
    },
    // 跳转可视化大屏
    handleScreen() {
      let params = `user=${sessionStorage.getItem('USER_encode')}&psd=${sessionStorage.getItem('PWD_encode')}`

      window.open('http://agri.bbyiot.com/screen/login?' + params, '_blank')
    }
  }
}
</script>
<style lang="scss">
.container_1 {
  margin-top: 5px;
  height: 70px;
  width: 400px;
  overflow: hidden;
  font-size: 14px;
}
/* 设置内容的样式 */
.content_1 {
  position: relative;
  top: 0;
  white-space: nowrap;
  animation: scroll-up 12s linear infinite;
}
/* 定义动画效果 */
@keyframes scroll-up {
  0% {
    transform: translateY(-15%);
  }
  20% {
    transform: translateY(-15%);
  }
  40% {
    transform: translateY(-150%);
  }
  60% {
    transform: translateY(-150%);
  }
  70% {
    transform: translateY(-290%);
  }
  90% {
    transform: translateY(-290%);
  }
  100% {
    transform: translateY(-400%);
  }
}
.logo-img-top {
  width: 200px;
}
.todayW {
  overflow: hidden;

  white-space: nowrap;
  text-overflow: ellipsis;
}
.early-warning-container {
  display: flex;
  .waring_lable {
    width: 110px;
    font-size: 16px;
    font-weight: 500;
    white-space: nowrap;
  }
}
.icon_border {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 160px;
}

.img_wH {
  width: 76px;
  height: 71px;
}
.dapeng-box {
  cursor: pointer;
  float: left;
  width: 95%;
  margin: 2%;
  box-sizing: border-box;
  position: relative;
  height: 572px;
}
.dapeng-img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 480px;
  height: 480px;
}
.dapeng-row {
  width: 100%;
  height: 100%;
  // margin-left: 3%;
  position: relative;
}
.dapeng-list-img {
  width: 44px;
  height: 44px;
}
.dapeng-span {
  float: left;
  height: 80px;
  line-height: 70px;
  text-align: center;
  font-size: 14px;
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  padding-left: 30px;
  margin-top: 20px;
  width: 16.6%;
}
.hiden_span {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
  margin-left: 5px;
  width: 100%;
  // height: 25px;
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000c17;
  line-height: 21px;
}
.hiden_span2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
  margin-left: 5px;
  width: 100%;
  height: 40px;
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000c17;
  line-height: 40px;
}
.dapeng-title {
  position: absolute;
  top: -25px;
  left: 0%;
  width: 100%;
  height: 36px;
  font-size: 26px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #333;
  line-height: 36px;
  margin-top: -15px;
}
.dapeng-child-title {
  margin-left: 10px;
  font-size: 19px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 27px;
}
.dapeng-child-time {
  float: right;
  margin-right: 40px;
  height: 27px;
  font-size: 19px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 27px;
}
.dapeng-video {
  width: 88px;
  height: 88px;
  position: absolute;
  right: -20px;
  top: 65px;
  border-radius: 50%;
  cursor: pointer;
}
.option {
  /*用div的样式代替select的样式*/
  margin: 100px;
  width: 140px;
  height: 40px;
  /*border-radius: 5px;*/
  /*盒子阴影修饰作用,自己随意*/
  /* box-shadow: 0 0 5px #ccc;*/
  border: 1px solid #cccccc;
  position: relative;
}
.option select {
  /*清除select的边框样式*/
  border: none;
  /*清除select聚焦时候的边框颜色*/
  outline: none;
  /*将select的宽高等于div的宽高*/
  width: 100%;
  height: 40px;
  line-height: 40px;
  /*隐藏select的下拉图标*/
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  /*通过padding-left的值让文字居中*/
  padding-left: 20px;
}
/*使用伪类给select添加自己想用的图标*/
.option:after {
  content: '';
  width: 14px;
  height: 8px;
  // background: url(../assets/arrow-down.png) no-repeat center;
  /*通过定位将图标放在合适的位置*/
  position: absolute;
  right: 20px;
  top: 41%;
  /*给自定义的图标实现点击下来功能*/
  pointer-events: none;
}
.alerm-item {
  float: left;
  margin-left: 10px;
}
.a666 {
  font-size: 14px !important;
}
.dapeng-span0 {
  position: absolute;
  top: 20%;
  left: 25%;
  display: flex;
  align-items: center;
}
.dapeng-span1 {
  position: absolute;
  top: 45%;
  left: 20%;
  display: flex;
  align-items: center;
}
.dapeng-span2 {
  position: absolute;
  top: 70%;
  left: 25%;
  display: flex;
  align-items: center;
}
.dapeng-span3 {
  position: absolute;
  top: 20%;
  left: 67%;
  display: flex;
  align-items: center;
}
.dapeng-span4 {
  position: absolute;
  top: 45%;
  left: 72%;
  display: flex;
  align-items: center;
}
.dapeng-span5 {
  position: absolute;
  top: 70%;
  left: 67%;
  display: flex;
  align-items: center;
}
.all-content-container_ {
  overflow: auto;
  height: 80vh !important;
}
.chong_box {
  width: 600px;
  height: 600px;
  position: absolute;
  top: 50px;
  right: 270px;
  border: 3px solid #cccccc;
  background: #fff;
  z-index: 9;
}
.chong_box_show {
  position: absolute;
  top: 100px;
  right: 30px;
  color: #333333;
  font-weight: bold;
  width: 210px;
  height: 64px;
  background: #f5f5f5;
  border-radius: 37px;
  border: 1px solid #979797;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 8;
  cursor: pointer;
}
.qxz {
  top: 180px;
}
.bz {
  top: 260px;
}
.sz {
  top: 340px;
}
.device_box_show {
  position: absolute;
  top: 50px;
  left: 30px;
  color: #333333;
  font-weight: bold;
  width: 210px;
  height: 64px;
  background: #f5f5f5;
  border-radius: 37px;
  border: 1px solid #979797;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  cursor: pointer;
}
.bottom {
  cursor: pointer;
  font-size: 18px;
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 999;
}
.device {
  position: absolute;
  top: 50px;
  left: 20px;
  width: 294px;
  height: 400px;
  background: #fafafa;
  border-radius: 6px;
  z-index: 9999;
}
.device_title {
  font-weight: 500;
  font-size: 16px;
  margin: 15px;
  font-weight: bold;
  color: #333333;
  display: flex;
  align-items: center;
}
.deviceList {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
}
.cirle {
  width: 5px;
  margin-right: 5px;
  height: 15px;
  background: #3da4fa;
  border-radius: 3px;
}
.device_num {
  font-size: 14px;
  color: #666666;
}
.device_name {
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}
.device_name_title {
  width: 100px;
  white-space: nowrap;
}
.center_text {
  width: 100%;
  height: 36px;
  font-size: 26px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #333;
  line-height: 36px;
  /* margin-left: 60px; */
}
</style>
